import TemplateView from "../../../../TemplateView"
import messageResource from "../../../../messageResource"
import WordsFilter from "../../components/WordsFilter"
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'
import ModalAlert from '../../../../components/modalAlert/ModalAlert'

export default class TabContentHeader extends TemplateView {
    constructor({
        onAllRevoked = () => {},
        onSearchChanged = (text) => {},
        onSearchToggled = () => {},
        onClickToggleArchivedButton = () => {},
    }) {
        super();

        this.params = {
            onAllRevoked,
            onSearchChanged,
            onSearchToggled,
            onClickToggleArchivedButton,
        }

        this.state = {
            title: "",
            searchText: null,
            searchOpen: false,
            hideArchivedButtonText: "",
            showArchivedButtonText: "",
            showToggleArchivedButton: true,
            isShowArchivedEntities: false,
            searchDisabled: false,
            revokeDisabled: false,
            revokeConfirmationText: '',
        }

        this.onStatePropertyChanged('title', (title) => this.find(".title").html(title))
        this.onAnyStatePropertyChanged(['searchText', 'searchOpen'], ({searchText, searchOpen}) => {
            this.wordFilter.setState({
                open: searchOpen,
                text: searchText ? searchText : "",
            })
        })

        this.onAnyStatePropertyChanged(['hideArchivedButtonText', 'showArchivedButtonText', 'isShowArchivedEntities'], () => {
            this._changeTextHideButton()
        })

        this.onStatePropertyChanged('showToggleArchivedButton', (show) => {
            this.$toggleArchivedButton.toggle(show)
            this.find(".hideSeparator").toggle(show)
        })

        this.onStatePropertyChanged('searchDisabled', disabled => {
            this.wordFilter.setState({
                disabled: disabled,
            })
        })

        this.onStatePropertyChanged('revokeDisabled', disabled => {
            this.$revokeButton.toggleClass('disabled', disabled)
        })

        this.onStatePropertyChanged('revokeConfirmationText', revokeConfirmationText => {
            this.revokeDialog.setState({
                text: revokeConfirmationText,
            })
        })
    }

    templateHtml() {
        return "<div class='additionalInfo'>" +
               "  <div class='searchFieldArea'>" +
               "    <div class='title ellipsis'/>" +
               "    <div class='searchButton'/>" +
               "  </div>" +
               "  <div class='rightContainer'>" +
               "    <div class='vertical-separator hideSeparator'></div>" +
               "    <div class='toggleArchivedButton'></div>" +
               "    <div class='vertical-separator'></div>" +
               "    <div class='revokeButton'><%-revokeAll%> <div class='revokeEdgeButton'></div></div>" +
               "  </div>" +
               "</div>"
    }

    templateModel() {
        return {
            revokeAll: messageResource.getMessage("work_assignments.panel.revoke_all"),
        }
    }

    afterRender() {

        this.$toggleArchivedButton = this.find(".toggleArchivedButton");

        this.$revokeButton = this.find(".revokeButton")

        this.revokeDialog = new ModalAlert({
            showCancelButton: true,
            onConfirm: ()=> {
                this.$revokeButton.toggleClass('active', false)
                this.params.onAllRevoked()
            },
            okButtonLabel: messageResource.getMessage('assignments.panels.ok_revoke'),
            onCancelButtonClick: () => {
                this.$revokeButton.toggleClass('active', false)
            },
        }).init(this.$containerEl)

        this.$revokeButton.click(() => {
            if (!this.state.revokeDisabled) {
                this.$revokeButton.toggleClass('active', true)
                this.revokeDialog.setState({
                    pointerPosition: ModalAlertPointerPosition.RIGHT,
                    additionalClass: 'revokeAllConfirmationDialogue',
                    offsets: {
                        left: 40,
                        top: 10,
                    },
                }).showAt(this.$revokeButton)
            }
        })

        this.$toggleArchivedButton.click(() => this.params.onClickToggleArchivedButton(!this.state.isShowArchivedEntities));

        this.wordFilter = new WordsFilter({
            onChange: (text) => this.params.onSearchChanged(text),
            onShow: () => this.params.onSearchToggled(true),
            onHide: () => this.params.onSearchToggled(false),
        }).init(this.find(".searchButton"))
    }

    _changeTextHideButton() {
        if (!this.state.isShowArchivedEntities) {
            this.$toggleArchivedButton.text(this.state.showArchivedButtonText)
        } else {
            this.$toggleArchivedButton.text(this.state.hideArchivedButtonText)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/TabContentHeader.js